import styled from "styled-components";

export const Wrapper = styled.div`
    margin: auto;
    text-align: center;

`